import { useOktaAuth } from "@okta/okta-react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit,faQuestionCircle,faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { Department } from "../../services/coworkerApiCalls/Department/DepartmentsTypes";
import { useState } from "react";
import { createDepartment, deleteDepartment, updateDepartment } from "../../services/coworkerApiCalls/Department/Department";
import { Tooltip } from "react-tooltip";
import { useDataApiSpacesByServiceId } from "../../Hooks/useDataServicesApi";
//import { useDataApiSpace } from "../../Hooks/useDataSpacesApi";

type DepartmentCrudProperties = Department;

// Définition du type DepartmentData
type DepartmentData = {
  id: number;
  name: string;
};

// eslint-disable-next-line unicorn/consistent-function-scoping
const handleNavigation = (path: string) => {
  window.location.href = path; // Change l'URL et recharge la page
};


const delayNavigation = (path: string, delay: number) => {
  setTimeout(() => {
    handleNavigation(path);
  }, delay);
};

function onDelete(token: string, id: number) {
  const userConfirmed = confirm("Êtes vous sur de vouloir supprimer ?")
  if (userConfirmed) {
    // L'utilisateur a confirmé, appeler la fonction deleteSpace
    void deleteDepartment(token, id);
    delayNavigation("/departments", 2000);
  }
}

const DepartmentCrud: React.FC<DepartmentCrudProperties> = ({id,name}) => {

  const { authState } = useOktaAuth();
  const idToken = authState!.idToken!.idToken; 
  const allSpaces = useDataApiSpacesByServiceId(id);

  // To avoid problem with hooks in loop
  const spacesReplacement = allSpaces;

  let spacesTotal = 0;
  let spacesTooltip = "Quota par espace de Coworking : <br>";

  // Construct the tooltip message to have each space / quota details of a service 
  
  if(spacesReplacement){
    spacesTotal = spacesReplacement.length;
    if(spacesTotal == 0){
      spacesTooltip = "Aucun espace n'est associé à ce service."
    }
    else{
      for(const space of spacesReplacement) {
        for(const quota of space.quotas){
          if(quota.departmentId == id){
            spacesTooltip += " • " + space.name +  " : " +  quota.value.toString() + " " + "places" + "<br>";  
          }
        }
      }
    }
  }

  return (

    <tr className="border-b border-gray-200">
        <td className="p-4"><strong className="text-gray-500"> {name} </strong></td>
        <td className="p-4"><img className="w-24" src="https://www.manitou-group.com/wp-content/themes/manitou/assets/img/ManitouGroup_Logo_Transp.png" alt="Logo Manitou" /></td>
        <td className="p-4">
            <Tooltip id="my-tooltip-multiline"/>
            <a data-tooltip-id="my-tooltip-multiline" data-tooltip-html={spacesTooltip} data-tooltip-place="top">
              <span className="tooltip-icon">
                {spacesTotal} <FontAwesomeIcon icon={faQuestionCircle} className="question-mark" />
              </span>
            </a>
        </td>
        <td className="p-4 flex justify-end items-center">
            <Link to={`/edit-department/${id}`}>
              <button
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mr-2"
              ><FontAwesomeIcon icon={faEdit} /></button>
            </Link>

            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              onClick={() => onDelete(idToken, id)}
            ><FontAwesomeIcon icon={faTrashAlt} /></button>
        </td>
    </tr>
  )
}

const DepartmentEdit: React.FC<Department> = ({id, name}) => {

  const [idEdit] = useState(id)
  const [nameEdit, setNameEdit] = useState(name)

  const { authState } = useOktaAuth();
  const idToken = authState!.idToken!.idToken;
  
  
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    const departmentData: DepartmentData = {
      id: idEdit, 
      name: nameEdit,
    };

    if (idEdit === 0) {
      void createDepartment(idToken, departmentData)
      delayNavigation("/departments", 2000);
    } else {
      void updateDepartment(idToken, departmentData)
      delayNavigation("/departments", 2000);
    }

    // Ici, vous pouvez gérer la logique pour ajouter l'article (par exemple, envoi à une API)
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNameEdit(event.target.value);
  };

  return (
    <form onSubmit={handleSubmit} action="/add-space" method="post" className=" flex flex-col gap-6 bg-white shadow-lg rounded-lg p-8">
      <div className="flex justify-between items-center mb-5"> 
        <h2 className="text-2xl font-semibold">
          {id ? 
            <>Modifier </> 
            : 
            <>Ajouter </>
          } 
          un service
        </h2>
        {nameEdit !== "" && (
          <button type="submit" className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ">
              {id ? 
                <>Modifier </> 
                : 
                <>Ajouter </>
              } 
              le service
          </button>
        )}
      </div>
      
      <div className="form-group">
        <label htmlFor="name" className="text-lg font-semibold mb-2">Nom</label>
        <input
          type="text"
          name="name"
          value={nameEdit}
          onChange={handleNameChange}
          placeholder="Nom"
          className="mt-1 mb-3 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
          required
        />
      </div>
    </form>
  );
};

export {DepartmentCrud, DepartmentEdit };

